import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["isVisible", "className", "overlayClassName", "onClose"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from "react";
import clsx from 'clsx';
import noop from 'lodash/noop';
import { useEffect, useRef } from 'react';
import globalEvents from '@/utils/globalEvents';
import logger from '@/utils/logger';
import styles from './styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var CloseIcon = function CloseIcon(props) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      d: "M17.1548 0.488155C17.8057 -0.162718 18.861 -0.162718 19.5118 0.488155C20.1627 1.13903 20.1627 2.1943 19.5118 2.84518L12.357 10L19.5118 17.1548C20.1627 17.8057 20.1627 18.861 19.5118 19.5118C18.861 20.1627 17.8057 20.1627 17.1548 19.5118L10 12.357L2.84518 19.5118C2.1943 20.1627 1.13903 20.1627 0.488156 19.5118C-0.162719 18.861 -0.162719 17.8057 0.488156 17.1548L7.64298 10L0.488156 2.84518C-0.162718 2.1943 -0.162718 1.13903 0.488156 0.488155C1.13903 -0.162718 2.19431 -0.162718 2.84518 0.488155L10 7.64298L17.1548 0.488155Z",
      fill: "#BABDCC"
    })
  }));
};

CloseIcon.defaultProps = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const PREFIX = 'common: components: ModalHoc:';
const CLOSE_ELEMENT_SELECTOR = '[data-modal=trigger-close]';
const OVERLAY_ELEMENT_SELECTOR = '[data-modal=overlay]';
export const CloseButton = _ref => {
  let {
    className
  } = _ref;
  return /*#__PURE__*/_jsx("button", {
    className: className,
    type: "button",
    "data-modal": "trigger-close",
    children: /*#__PURE__*/_jsx(CloseIcon, {})
  });
};

const ModalElement = _ref2 => {
  let {
    children,
    modalClass,
    closeButtonClass = '',
    hasCloseButton,
    positionToParentScroll = false,
    triggerOnClose
  } = _ref2;
  const modalEl = useRef(null);
  useEffect(() => {
    if (!positionToParentScroll || !modalEl.current) return;
    const modalElement = modalEl.current;
    const parentEl = modalElement.parentElement;
    requestAnimationFrame(() => {
      const nearestNonOverlay = parentEl ? parentEl.closest(':not([data-modal="overlay"])') : null;

      if (nearestNonOverlay) {
        modalElement.style.top = `${nearestNonOverlay.scrollTop}px`;
        modalElement.style.left = `${nearestNonOverlay.scrollLeft}px`;
      }
    });
  }, [positionToParentScroll]);
  return /*#__PURE__*/_jsxs("div", {
    ref: modalEl,
    className: clsx(styles.container, modalClass || ''),
    role: "dialog",
    "data-testid": "modal",
    onClick: triggerOnClose,
    children: [hasCloseButton ? /*#__PURE__*/_jsx(CloseButton, {
      className: clsx(styles.container__closeButton, closeButtonClass)
    }) : /*#__PURE__*/_jsx(_Fragment, {}), children]
  });
}; // Modal high level component

/* eslint-disable */


const ModalHoc = function (Content) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const {
    modalClass = '',
    overlayclass = '',
    closeButtonClass = '',
    removeOverlay = false,
    hasCloseButton = true,
    closeOnEvent = true,
    closeOnOverlayClick = true,
    indexable = false
  } = options;

  const Modal = _ref3 => {
    let {
      isVisible = false,
      className = '',
      overlayClassName = '',
      onClose = () => false
    } = _ref3,
        initialProps = _objectWithoutProperties(_ref3, _excluded);

    const props = _objectSpread({
      isVisible,
      onClose
    }, initialProps); // Trigger modal open event on
    // each time it is visible


    useEffect(() => {
      if (!props.isVisible) return;
      const onOpen = props.onOpen || noop;
      globalEvents.trigger('modalOpen');
      requestAnimationFrame(onOpen);
    }, [props.isVisible]); // Allow any modal close global event subscribers
    // to fire before invoking the modal close callback

    const handleOnClose = () => {
      globalEvents.trigger('modalClose');
      if (!closeOnEvent) return;
      setTimeout(props.onClose, 100);
    };

    const isOverlayClick = evt => {
      var _evt$target;

      return evt === null || evt === void 0 ? void 0 : (_evt$target = evt.target) === null || _evt$target === void 0 ? void 0 : _evt$target.matches(OVERLAY_ELEMENT_SELECTOR);
    }; // Event delegator that checks if
    // click events on children should
    // trigger close


    const triggerOnClose = evt => {
      var _evt$target2, _evt$target3;

      const isCloseEl = evt === null || evt === void 0 ? void 0 : (_evt$target2 = evt.target) === null || _evt$target2 === void 0 ? void 0 : _evt$target2.matches(CLOSE_ELEMENT_SELECTOR);
      const isParentOfCloseEl = Boolean(evt === null || evt === void 0 ? void 0 : (_evt$target3 = evt.target) === null || _evt$target3 === void 0 ? void 0 : _evt$target3.closest(CLOSE_ELEMENT_SELECTOR));
      if (isCloseEl || isParentOfCloseEl) handleOnClose();
    };

    if (removeOverlay) {
      if (indexable) {
        logger.warn(`${PREFIX} indexing non-overlayed modals is not currently supported`);
      }

      return props.isVisible ? /*#__PURE__*/_jsx(ModalElement, {
        modalClass: clsx(modalClass, className),
        closeButtonClass: closeButtonClass,
        triggerOnClose: triggerOnClose,
        hasCloseButton: hasCloseButton,
        positionToParentScroll: props.positionToParentScroll,
        children: /*#__PURE__*/_jsx(Content, _objectSpread({}, props))
      }) : /*#__PURE__*/_jsx(_Fragment, {});
    }

    return props.isVisible || indexable ? /*#__PURE__*/_jsx("div", {
      className: clsx(styles.overlay, overlayclass || '', overlayClassName || '', indexable ? styles['-indexable'] : '', indexable && props.isVisible ? styles['-show'] : ''),
      onClick: evt => isOverlayClick(evt) && closeOnOverlayClick && handleOnClose(),
      "data-modal": "overlay",
      "data-testid": "modal-overlay",
      children: /*#__PURE__*/_jsx(ModalElement, {
        modalClass: clsx(modalClass, className),
        closeButtonClass: closeButtonClass,
        triggerOnClose: triggerOnClose,
        hasCloseButton: hasCloseButton,
        children: /*#__PURE__*/_jsx(Content, _objectSpread({}, props))
      })
    }) : /*#__PURE__*/_jsx(_Fragment, {});
  };
  /* eslint-enable */


  return Modal;
};

export default ModalHoc;